export default "/fonts/PublicSans-Black.ttf?cc3e96f498ac71b793ddf5397bf0dfc3";